import axios from 'axios';
import moment from 'moment';
import React, { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import useOnceEffect from '../../Hooks/useOnceEffect';
import Avatar from '../../utils/Avatar/Avatar';
import { es_locale } from '../../utils/Moment/es_local';
import _472 from '../../static/images/472.png';

const GroupContext = React.createContext()
const PostContext  = React.createContext()

const Group = () => {

    const [group, setGroup] = useState({});
    const { groupId } = useParams()

    useOnceEffect(() => {

        let is_mounted = true

        axios.get(`groups/${groupId}`)
            .then(res => {
                if(!is_mounted)
                    return

                setGroup({
                    group: res.data
                })
            })

        return () => {
            is_mounted = false
        }
    })

    return (
        <GroupContext.Provider value={[group, setGroup]}>
            <main className='container'>
                <div className='row'>
                    <div className='col-12 col-md-3 col-lg-3 my-3'>
                        <GroupLeft />
                    </div>

                    <div className='col-12 col-md-9 col-lg-9 my-3'>
                        <GroupRight />
                    </div>
                </div>
            </main>
        </GroupContext.Provider>
    );
};


function GroupRight() {

    const [posts, setPost] = useState([])

    return (
        <>
            <GroupHeader />
            <br /> <br />

            <PostContext.Provider value={[posts, setPost]}>
                <CreatePost />
                <br /> <br />
                <PostList />
            </PostContext.Provider>
            
        </>
    )
}

function GroupLeft() {

    const [group] = useContext(GroupContext)

    return (
        <section className='card border-radius'>
            <div className='card-body'>
                
                <div className='profile__cover-photo border-radius' style={{width: "5rem", height: "5rem", margin: "auto", border: "2px solid #9100ff" }}>
                    { group?.group?.image &&
                        <img src={group.group.image} alt='group-' className='img_profile img_cover' />
                    }
                </div>

                <p className='text-center'>{group?.group?.userName}</p>

            </div>
        </section>
    )
}


function GroupHeader() {

    const [state] = useContext(GroupContext)
    
    const { 
        group = {} 
    } = state

    return (
        <>
            
            <div className='border-radius bg-white'>
                
                    {group?.coverImage &&
                        <div className='profile__cover-photo'>
                            <img src={group.coverImage} alt='group-cover' className='img_cover' />
                        </div>
                    }

                <section className='d-flex'>

                    <div className='mx-3 transform_top_50'>
                        <Avatar style={{
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            BackgroundPosition: "center center"
                        }} >
                            {group?.image && 
                                <img src={group.image} alt='group-per' className='img_cover' />
                            }
                        </Avatar>
                    </div>

                    <div>
                        <h2>{group?.name}</h2>
                    </div>
                </section>
            </div>

            <br /><br />

            <div className='card bg-white border-radius'>
                <div className="card-body">
                    <h5>Acerca de este Grupo</h5>
                    <p className='text-grey'>
                        {group?.description}
                    </p>
                    
                    <hr/>

                    <h5>Reglas del grupo / Información adicional</h5>
                    <p className='text-grey'>
                        {group?.rules}
                    </p>
                </div>
            </div>
        </>
    )
}

function CreatePost() {

    const [publicacion , setPublicacion] = useState("")
    const [posts, setPosts] = useContext(PostContext)
    const { groupId } = useParams()

    function createPost() {

        axios.post(`/groups/${groupId}/posts`, { 
            description: publicacion
        })
        .then(res => {


            let aux = [res.data.data, ...posts]
            setPosts([...aux])

            toast.success(res.data.message)
        })
        .catch(() => {
            toast.error("No se pudo subir la publicación")
        })
    }

    return (
        <>
            <div className='card border-radius'>
                <div className='card-body'>
                    <h5>Comparte una publicación</h5>


                    <div className='form-group border-radius my-3'>
                        <textarea maxLength={255} placeholder='&#9998; Iniciar una publicación' value={publicacion} onChange={({target}) => setPublicacion(target.value)} className='form-control border-radius' rows={5} />
                    </div>

                    <div className='d-flex justify-content-end my-3'>
                        <button onClick={createPost} style={{width: "15rem"}} className='btn-deg'>Publicar</button>
                    </div>
                </div>
            </div>
        </>
    )
}

function PostList() {

    const [state, setState] = useContext(PostContext)
    const { groupId } = useParams()
    moment.locale("es", es_locale)

    useOnceEffect(() => {

        axios.get(`/groups/${groupId}/posts`)
        .then(res => {
            setState(res.data)
        })
    })


    function getDate(date) {
        let date1 = moment(new Date())
        let date2 = moment(date, "YYYY-MM-DD hh:mm")

        if(
            date1.month === date2.month &&
            date1.day  === date2.day &&
            date1.year === date2.year
        ) {
            return date2.fromNow()
        }

        return date2.format("dddd, MMMM Do YYYY, h:mm:ss a")
        
    }

    return (
        <>
            {state.map((elm, i) => {

                return (
                    <section key={i} className='card border-radius my-3'>
                        <div className='card-body'>
                            <div className='post-header'>
                                <Avatar style={{margin: "0 1rem 0 0"}} type='circle' size='sm' color='grey'>
                                    <p className='text-light' style={{margin: 0}}>{elm.userName?.split("")[0] ?? ""}</p>
                                </Avatar>

                                <div className='ml-3'>
                                    <p>{elm.userName}</p>
                                    {getDate(elm.creationDate)}
                                </div>
                            </div>

                            <div className='post-body'>
                                <p className='text-grey'>
                                    {elm.description.split("\n").map(_elm => <>{_elm} <br /> </> )}
                                </p>
                            </div>

                            <div className='post-footer'>

                            </div>
                        </div>
                    </section>
                );
            })}
        </>
    );
}

export default Group;